interface SectionDividerProps {
  from: string;
  to: string;
}

export const SectionDivider = ({ from, to }: SectionDividerProps) => (
  <div className="relative" style={{ marginTop: "-1px", marginBottom: "-1px" }}>
    <svg
      viewBox="0 0 1440 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
      className="w-full block"
      style={{ height: "60px", background: from }}
    >
      <path
        d="M0,0 L1440,0 L1440,30 Q1080,60 720,30 Q360,0 0,30 Z"
        fill={to}
      />
    </svg>
  </div>
);
